import axiosInstance from "../services/secureApi";

/* ================= GET ALL ORDERS ================= */
export const getOrdersApi = async (page = 1, limit = 10) => {
  try {
    const response = await axiosInstance.get("/orders/list", {
      params: {
        page,
        limit,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Get Orders Error:", error.response?.data);
    throw error;
  }
};

export const downloadInvoice = async (orderId) => {
  try {
    const response = await axiosInstance.post(
      "/admin/orders/download-invoice",
      {
        orderId,
      }
    );

    return response.data;
  } catch (error) {
    console.error("DOWNLOAD INVOICE ERROR", error);
    throw error;
  }
};

/* ================= GET DELIVERED ORDERS ================= */
/* ================= GET DELIVERED ORDERS ================= */
export const getDeliveredOrdersApi = async ({
  fromDate = "",
  toDate = "",
  status = "",
} = {}) => {
  try {
    const params = {};

    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;
    if (status) params.status = status;

    const response = await axiosInstance.get("/orders/list/delivered", {
      params,
    });

    return response.data;
  } catch (error) {
    console.error("Get Delivered Orders Error:", error.response?.data);
    throw error;
  }
};

/* ================= GET ONGOING ORDERS ================= */
export const getOngoingOrdersApi = async (
  page = 1,
  limit = 10,
  category = "",
  { fromDate = "", toDate = "", status = "" } = {},
) => {
  try {
    const params = { page, limit };
    if (category) params.category = category;
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;
    if (status) params.status = status;

    const response = await axiosInstance.get("/orders/list/ongoing", {
      params,
    });

    return response.data;
  } catch (error) {
    console.error("Get Ongoing Orders Error:", error.response?.data);
    throw error;
  }
};

export const exportOrder = async ({ fromDate = "", toDate = "", status = "" } = {}) => {
  const params = {};
  if (fromDate) params.fromDate = fromDate;
  if (toDate) params.toDate = toDate;
  if (status) params.status = status;

  const response = await axiosInstance.get(
    "admin/orders/export/delivered",
    {
      params,
      responseType: "blob",
    }
  );

  return response;
};

export const exportOngoingOrders = async ({
  fromDate = "",
  toDate = "",
  status = "",
} = {}) => {
  const response = await axiosInstance.get("/orders/export/ongoing", {
    params: { fromDate, toDate, ...(status ? { status } : {}) },
    responseType: "blob",
  });

  return response;
};

export const getOrderDetails = async (orderId) => {
  try {
    const response = await axiosInstance.get(
      `/admin/orders/view/${orderId}`
    );

    return response.data;
  } catch (error) {
    console.error("Get Order Details Error:", error.response?.data);
    throw error;
  }
};
